module.exports = __webpack_public_path__ + "img/c02_buildingtechmountedtraining_Normal_ua.1fc3fdb9.webp";